import { env } from "src/env";
import { SupportedLocale } from "src/internationalization/locale/supported.locale.enum.ts";

const DEFAULT_LOCALE = SupportedLocale.FrFR;

const isSupportedLocale = (locale: string): locale is SupportedLocale => {
  return Object.values(SupportedLocale).includes(locale as SupportedLocale);
};

export const getStoredLocale = (): SupportedLocale => {
  const locale = localStorage.getItem("locale") ?? "";
  if (isSupportedLocale(locale)) {
    return locale;
  }
  if (isSupportedLocale(env.defaultLocale)) {
    return env.defaultLocale;
  }
  return DEFAULT_LOCALE;
};
